import { render, staticRenderFns } from "./barndImg.vue?vue&type=template&id=08be60ec&scoped=true&"
import script from "./barndImg.vue?vue&type=script&lang=js&"
export * from "./barndImg.vue?vue&type=script&lang=js&"
import style0 from "./barndImg.vue?vue&type=style&index=0&id=08be60ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be60ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08be60ec')) {
      api.createRecord('08be60ec', component.options)
    } else {
      api.reload('08be60ec', component.options)
    }
    module.hot.accept("./barndImg.vue?vue&type=template&id=08be60ec&scoped=true&", function () {
      api.rerender('08be60ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/comps/barndImg.vue"
export default component.exports